export enum InquiryEvents {
  addInquiryClicked = 'Add Inquiry Clicked',
  addInquiryClosed = 'Add Inquiry Closed',
  detailClosed = 'Inquiry Detail Closed',
  detailOpened = 'Inquiry Detail Opened',
  inquiryCreated = 'Inquiry Created',
  inquiryUpdated = 'Inquiry Updated',
  reloadInquiriesClicked = 'Reload Inquiries Clicked',
  nextContactDateUpdated = 'Inquiry Next Contact Date Updated',
  psrAssigned = 'Inquiry PSR Assigned',
  psrUnassigned = 'Inquiry PSR Unassigned',
  quickNoteAdded = 'Inquiry Quick Note Added',
  rcAssigned = 'Inquiry RC Assigned',
  rcUnassigned = 'Inquiry RC Unassigned',
  asAssigned = 'Inquiry AS Assigned',
  asUnassigned = 'Inquiry AS Unassigned',
  supervisorAssigned = 'Inquiry Supervisor Assigned',
  supervisorUnassigned = 'Inquiry Supervisor Unassigned',
  statusUpdated = 'Inquiry Status Updated',
  tableSorted = 'Inquiry List Sorted',
  tableFiltered = 'Inquiry List Filtered',
  tablePageChanged = 'Inquiry List Page Changed',
  tablePageSizeChanged = 'Inquiry List Page Size Changed',
  admissionConsultationScheduleClicked = 'Admission Consultation - Schedule Button Clicked',
  admissionConsultationSlotSelected = 'Admission Consultation - Appointment Slot Selected',
  admissionConsultationContinueClicked = 'Admission Consultation - Continue Button Clicked',
  admissionConsultationBackClicked = 'Admission Consultation - Back Button Clicked',
  admissionConsultationConfirmed = 'Admission Consultation - Confirm Button Clicked',
  admissionConsultationCancelKebabOptionClicked = 'Admission Consultation - Cancel Kebab Option Clicked',
  admissionConsultationEditAppointmentKebabOptionClicked = 'Admission Consultation - Edit Appointment Kebab Option Clicked',
  admissionConsultationCancelled = 'Admission Consultation - Confirm Cancellation Button Clicked',
}

export interface InquiryEventProps extends Record<string, unknown> {
  inquiryId: string;
  source?: 'Inquiry List' | 'Inquiry Detail';
}
